import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { capeGirardeauConfig } from "./data";

export default function CapeGirardeauPage() {
  return <CityPageTemplate config={capeGirardeauConfig} />;
}